
const USER_AGENT = navigator.userAgent.toLowerCase();


const CONTAINS_OPERA = /opera|opr/.test(USER_AGENT);
const CONTAINS_MSIE = /msie/.test(USER_AGENT);
const CONTAINS_TRIDENT = /trident/.test(USER_AGENT);
const CONTAINS_APPLEWEBKIT = /\sapplewebkit\//.test(USER_AGENT);
const CONTAINS_CHROME = /chrome/.test(USER_AGENT);
const CONTAINS_SAFARI = /safari/.test(USER_AGENT);
const CONTAINS_FIREFOX = /firefox/.test(USER_AGENT);

export const isIE = (CONTAINS_TRIDENT || CONTAINS_MSIE) && !CONTAINS_OPERA && 'msSaveBlob' in navigator;
export const isIE10 = ( CONTAINS_MSIE) && !CONTAINS_OPERA && USER_AGENT.indexOf('compatible') !== -1;
export const isIEAtLeast11 = !CONTAINS_MSIE && CONTAINS_TRIDENT && !CONTAINS_OPERA;
export const isEdge = USER_AGENT.indexOf('edg') > -1;
export const isOpera =  CONTAINS_OPERA;
export const isWebkit = CONTAINS_APPLEWEBKIT;
export const isChrome = !isOpera && CONTAINS_CHROME && !!window.chrome;
export const isSafari = !(/huawei/.test(USER_AGENT)) && !isOpera && CONTAINS_SAFARI && !CONTAINS_CHROME;
export const isGecko = navigator.product == 'Gecko' && !isWebkit && !isOpera;
export const isFirefox = !isChrome && !isOpera && !isSafari && CONTAINS_FIREFOX;
export const isMaxthon =  /maxthon/.test(USER_AGENT); // Maxthon
export const isQuirksMode = document.CompactMode == 'BackCompact';
export const isQQ = /tencenttraveler/.test(USER_AGENT) || /qqbrowser/.test(USER_AGENT);
export const isSougou = /metasr/.test(USER_AGENT) || /sogou/.test(USER_AGENT);
export const isBaidu = /baidubrowser/.test(USER_AGENT) || /bidubrowser/.test(USER_AGENT);
export const isUC = /ucbrowser/.test(USER_AGENT);
export const isLiebao = /liebao/.test(USER_AGENT);
export const isMiuiBrowser = /miuibrowser/.test(USER_AGENT);
export const isHuaweiBrowser = /huaweibrowser/.test(USER_AGENT) || /huaweialp/.test(USER_AGENT);

export const is360 = (() => {
    if(isQQ || isUC || isSougou || isMiuiBrowser || isLiebao || isMaxthon) {
        return false;
    }
    if(USER_AGENT.indexOf('chrome') === -1) {
        return false;
    }
    const is360 = _mime("type", "application/vnd.chromium.remoting-viewer");
    function _mime(option, value) {
        const mimeTypes = navigator.mimeTypes;
        for (const mt in mimeTypes) {
            if (mimeTypes[mt][option] == value) {
                return true;
            }
        }
        return false;
    }
    return !window.chrome || is360;
})();

const operatingSystemRules = [
    ['iOS', /iP(hone|od|ad)/],
    ['Android OS', /Android/],
    ['BlackBerry OS', /BlackBerry|BB10/],
    ['Windows Mobile', /IEMobile/],
    ['Amazon OS', /Kindle/],
    ['Windows 3.11', /Win16/],
    ['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/],
    ['Windows 98', /(Windows 98)|(Win98)/],
    ['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/],
    ['Windows XP', /(Windows NT 5.1)|(Windows XP)/],
    ['Windows Server 2003', /(Windows NT 5.2)/],
    ['Windows Vista', /(Windows NT 6.0)/],
    ['Windows 7', /(Windows NT 6.1)/],
    ['Windows 8', /(Windows NT 6.2)/],
    ['Windows 8.1', /(Windows NT 6.3)/],
    ['Windows 10', /(Windows NT 10.0)/],
    ['Windows ME', /Windows ME/],
    ['Open BSD', /OpenBSD/],
    ['Sun OS', /SunOS/],
    ['Chrome OS', /CrOS/],
    ['Linux', /(Linux)|(X11)/],
    ['Mac OS', /(Mac_PowerPC)|(Macintosh)/],
    ['QNX', /QNX/],
    ['BeOS', /BeOS/],
    ['OS/2', /OS\/2/],
  ];
function detectOS(ua){
    if(!ua) ua = navigator.userAgent;
    let rule = operatingSystemRules.find((item)=>{
      let regex = item[1];
      let match = regex.test(ua);
      return !!match;
    })
    if(rule){
        return rule[0].toLowerCase();
    }
    return null;
}

export const osName = detectOS();

//export const BROWSER_VERSION = (() => {
//    if(isIE) {
//        return parseFloat(USER_AGENT.match(/msie (\d+)/)[1]);
//    } else if(isGecko) {
//        var geckoRelease = USER_AGENT.match(/rv:([\d\.]+)/);
//        if (geckoRelease) {
//            geckoRelease = geckoRelease[1].split('.');
//            return geckoRelease[0] * 10000 + (geckoRelease[1] || 0) * 100 + (geckoRelease[2] || 0) * 1;
//        }
//    } else if(isOpera) {
//        if(typeof opera !== 'undefined') {
//            return parseFloat(opera.version());
//        } else {
//            return parseFloat(USER_AGENT.match(/(opr|opera)\/(\d+(\.\d+)?)/)[2]);
//        }
//    } else if(isWebkit) {
//        return parseFloat(USER_AGENT.match(/ applewebkit\/(\d+)/)[1]);
//    }
//    return 0;
//})();

export const isIE8 = !!document.documentMode && document.documentMode < 8;
export const isIE8Compact = document.documentMode == 8;
export const isIE9Compact = document.documentMode == 9;
export const isIE10Compact = document.documentMode == 10;
//export const isIE7Compact = (BROWSER_VERSION == 7 && !document.documentMode) || document.documentMode == 7;
//export const isIE6Compact = (BROWSER_VERSION < 7 || isQuirksMode);
//export const isIE8OrLower = isIE8 || isIE8Compact || isIE7Compact  || isIE6Compact;

export const BROWSER_DETECTION = {
    ie: isIE,
    ieAtLeast11: isIEAtLeast11,
    edge: isEdge,
    opera: isOpera,
    webkit: isWebkit,
    chrome: isChrome,
    safari: isSafari,
    gecko: isGecko,
    firefox: isFirefox,
    maxthon: isMaxthon,
    quirksMode: isQuirksMode,
    'quirks-mode': isQuirksMode,
    qq: isQQ,
    sougou: isSougou,
    baidu: isBaidu,
    liebao: isLiebao,
    uc: isUC,
    miui: isMiuiBrowser,
    huawei: isHuaweiBrowser,
    '360': is360
};

let bVersion = '';
let matchResult = '';
let EDG_MATCH = /edg\/[\d.]+/gi;
let EDGE_MATCH = /edge\/[\d.]+/gi;
let IE_RV_MATCH = /rv\:[\d.]+/gi;
let IE10_MATCH = /msie [\d.]+/gi;// MSIE 10.0
let FIREFOX_MATCH = /firefox\/[\d.]+/gi;
let CHROME_MATCH = /chrome\/[\d.]+/gi;
let SAFARI_MATCH = /safari\/[\d.]+/gi;
let OPERA_MATCH = /opr\/[\d.]+/gi;
let QQ_MATCH = /qqbrowser\/[\d.]+/gi;
let UC_MATCH = /ubrowser\/[\d.]+/gi;
let MAXTHON_MATCH = /maxthon\/[\d.]+/gi;
let BAIDU_MATCH = /bidubrowser\/[\d.]+/gi;
let XIMI_MATCH = /xiaomi\/miuibrowser\/[\d.]+/gi;
let HUAWEI_MATCH = /huaweibrowser\/[\d.]+/gi;

// let LIEBAO_MATCH = /liebao\/[\d.]+/gi; Liebao browser currently not supported
// let QH360_MATCH = /qihu\/[\d.]+/gi; 360 UA lacks explicit browser type/version info
// let SOUGOU_MATCH = /metasr\/[\d.]+/gi; Sogou UA lacks explicit browser type/version info

if(isFirefox) {
    matchResult = USER_AGENT.match(FIREFOX_MATCH);
} else if(isMaxthon) {
    matchResult = USER_AGENT.match(MAXTHON_MATCH);
} else if(isQQ) {
    matchResult = USER_AGENT.match(QQ_MATCH);
} else if(isBaidu) {
    matchResult = USER_AGENT.match(BAIDU_MATCH);
} else if(isUC) {
    matchResult = USER_AGENT.match(UC_MATCH);
} else if(isMiuiBrowser) {
    matchResult = USER_AGENT.match(XIMI_MATCH);
} else if(isHuaweiBrowser) {
    matchResult = USER_AGENT.match(HUAWEI_MATCH);
} else if(isOpera) {
    matchResult = USER_AGENT.match(OPERA_MATCH);
} else if(isIE) {
    matchResult = USER_AGENT.match(IE_RV_MATCH);
    if(matchResult && typeof matchResult[0] !== 'undefined') {
        matchResult[0] = matchResult[0].replace(':', '/').replace('rv', 'ie');
    }else if(isIE10){
        matchResult = USER_AGENT.match(IE10_MATCH);
        if(matchResult && typeof matchResult[0] !== 'undefined') {
            matchResult[0] = matchResult[0].replace(':', '/').replace('rv', 'ie');
        }
    }
} else if(isEdge) {
    matchResult = USER_AGENT.match(EDGE_MATCH);
    if(!matchResult){
        matchResult = USER_AGENT.match(EDG_MATCH);
    }
} else if(isSafari) {
    matchResult = USER_AGENT.match(SAFARI_MATCH);
} else {
    if(isSougou || is360 || isLiebao) {
        matchResult = '';
    } else if(isChrome) {
        matchResult = USER_AGENT.match(CHROME_MATCH);
    }
}
if (matchResult && typeof matchResult[0] !== 'undefined') {
    bVersion = matchResult[0].replace('/', ' ');
}

// if(isSougou) {
//     bVersion = USER_AGENT.replace(/\s+/g, '/').match(SOUGOU_MATCH)[0].replace('/', ' ');
// }
// if(is360) {
//     bVersion = USER_AGENT.match(CHROME_MATCH)[0].replace('/', ' ');
// }
// if(isLiebao) {
//     bVersion = USER_AGENT.match(CHROME_MATCH)[0].replace('/', ' ');
// }
export const browserVersion = bVersion;